module.exports = __webpack_public_path__ + "img/no-content.svg";